/**
 * Config provisioning device (env / build).
 */

/**
 * Se impostato, `GET OfflineSync/organization-configs` usa `?organization_id=` (device mono-org).
 * @returns {number | null}
 */
export function getProvisionOrganizationIdFromEnv() {
  const raw = process.env.REACT_APP_OFFLINE_PROVISION_ORGANIZATION_ID
  if (raw == null || String(raw).trim() === '') return null
  const n = Number(String(raw).trim())
  return Number.isFinite(n) ? n : null
}
